<template>
  <div>
    <page-title-bar>
      <v-btn fab dark color="indigo" small @click="create()">
        <v-icon dark>add</v-icon>
      </v-btn>
    </page-title-bar>
    <!-- <app-section-loader :status="loader"></app-section-loader> -->
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <app-card
          :heading="$t('message.standard')"
          :fullBlock="true"
          colClasses="xl12 lg12 md12 sm12 xs12"
        >
          <v-data-table v-bind:headers="headers" :items="users" hide-actions>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.username }}</td>
              <td>{{ getCompanyName(props.item.company) }}</td>
              <td class="justify-center layout px-0">
                <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                <v-icon small @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </template>
          </v-data-table>
        </app-card>
        <v-dialog v-model="isUserFormVisible" persistent max-width="1000">
          <user-form
            :user="selectedUser"
            @close="onCloseUserForm"
            :is-create="isCreate"
            v-if="selectedUser !==null"
          ></user-form>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserForm from './UserForm'

export default {
    components: {
        UserForm
    },
    data() {
        return {
            headers: [
                {
                    text: 'Username',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Company'
                },
                {
                    text: 'Actions',
                    align: 'center'
                }
            ],
            selectedUser: null,
            isUserFormVisible: false,
            isCreate: false
        }
    },
    computed: {
        ...mapGetters(['users', 'companies']),
        dataSource: function() {
            if (this.$refs.grid) {
                const pivotGrid = this.$refs.grid.instance
                return pivotGrid.getDataSource()
            }
        }
    },
    methods: {
        getCompanyName(companyId) {
            const company = this.companies.find(c => c._id === companyId)
            return company ? company.Name : ''
        },
        create() {
            this.isUserFormVisible = true
            this.isCreate = true
            this.selectedUser = {
                isAdmin: false,
                settings: {
                    language: 'en',
                    season: 1,
                    darkMode: false
                }
            }
        },
        editItem(item) {
            this.selectedUser = item
            this.isUserFormVisible = true
            this.isCreate = false
        },
        deleteItem(item) {
            this.$confirm(`Do you really want to delete the user "${item.username}"?`, {
                color: 'warning',
                icon: 'warning',
                title: 'Warning'
            }).then(res => {
                if (res === true) {
                    this.$store.dispatch('removeUser', item._id)
                }
            })
        },
        onCloseUserForm() {
            this.selectedUser = null
            this.isUserFormVisible = false
            this.$store.dispatch('getEditableUsers')
        }
    },
    created() {
        //  const pivotGrid = this.$refs.grid.instance
        this.$store.dispatch('getEditableUsers')
    }
}
</script>
